// Pentest environment
import packageInfo from '../../../package.json';
import { documentationUrls } from './documentation-urls';

export const environment = {
  environment: 'pentest',
  production: true,
  devMode: false, //disables annoying features like lockscreen while developing
  ssoAllowed: false, // only available on staging & production

  version: packageInfo?.version,

  authAppURL: 'https://loginpentest.reconcept.nl',
  authApiURL: 'https://api.portfoliopentest.reconcept.nl',

  portfolioClientName: 'APOLLO_PORTFOLIO',
  portfolioAppURL: 'https://portfoliopentest.reconcept.nl',
  portfolioApiURL: 'https://api.portfoliopentest.reconcept.nl/graphql',

  aiApiUrl: 'https://api.aipentest.reconcept.nl/api/ai',

  workspaceAppURL: 'https://workspacepentest.reconcept.nl',
  workspaceApiURL: 'https://api.portfoliopentest.reconcept.nl/graphql',

  ...documentationUrls,

  // the authenticator title for this specific environment
  otpIssuer: 'Reconcept Pentest',
  otpBannerEnabled: true,

  environmentIndicator: {
    color: 'green',
    text: `Pentest`,
    icon: 'times',
  },
};
